module.exports = __webpack_public_path__ + "static/media/112.dd7c2a50.png";